import { createFileRoute } from '@tanstack/react-router'

import { CreditCardsPage } from '#/modules/billing/credit-cards-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/credit-cards')({
  component: CreditCardsPage,
  validateSearch: validateListSearch,
})
